import { render, staticRenderFns } from "./VimsPersonList.vue?vue&type=template&id=7281d72e&lang=html&"
import script from "./VimsPersonList.vue?vue&type=script&lang=js&"
export * from "./VimsPersonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports